import React, { useEffect, useImperativeHandle, useState } from "react";
import { Modal } from "antd";
import styles from "./index.module.scss";
import Header from "./components/Header";
import Aside from "./components/Aside";
import Footer from "./components/Footer";
import { ModalProps } from "antd/es/modal";
import Viewer from "./components/Viewer";
import { SourceItem } from "../../pages/ResourcePool/service";
import AsideLink from "./components/Aside/components/AsideLink";
import StuFooter from "./components/StuFooter";

interface CourseWareModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    data: SourceItem[];
    type?: "teacher" | "student";
}

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

const PreviewSourceModal = React.forwardRef<
    DataModalInstance,
    CourseWareModalProps
>(({ onOk, data, onCancel, type = "teacher", ...props }, ref) => {
    const [showAside, setShowAside] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [defaultId, setDefaultId] = useState(0);

    useImperativeHandle(ref, () => ({
        setPayload: payload => {
            setDefaultId(payload);
        }
    }));

    useEffect(() => {
        setActiveIndex(data.findIndex(item => item.id === defaultId));
    }, [defaultId]);

    return (
        <Modal
            title={null}
            footer={null}
            className={styles.root}
            closable={false}
            centered
            {...props}>
            <Header onCancel={onCancel} />

            <div className={styles.body}>
                <Aside
                    visible={showAside}
                    onToggle={() => setShowAside(!showAside)}>
                    {data.map((item, index) => (
                        <AsideLink
                            key={item.id}
                            active={index === activeIndex}
                            onClick={() => setActiveIndex(index)}
                            item={item}
                        />
                    ))}
                </Aside>

                <div className={styles.container}>
                    <div className={styles.main}>
                        <Viewer data={data[activeIndex]} />
                    </div>

                    {type === "teacher" ? (
                        <Footer
                            data={data[activeIndex]}
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                            listLength={data.length}
                        />
                    ) : (
                        <StuFooter
                            data={data[activeIndex]}
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                            listLength={data.length}
                        />
                    )}
                </div>
            </div>
        </Modal>
    );
});
export default PreviewSourceModal;
